import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['bg']

  connect() {
    this.onScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll)
  }

  onScroll() {
    if (this.hasBgTarget) {
      this.bgTarget.style.transform = `translateY(${window.scrollY * 0.22}px)`
    }
  }
}
